export enum ConversationEventTypes {
    ConversationCreated = 'ConversationCreated',
    ConversationEnded = 'ConversationEnded',
    ConversationMessageRead = 'ConversationMessageRead',
    MessageSentToConversation = 'MessageSentToConversation',
    ParticipantJoinedConversation = 'ParticipantJoinedConversation',
    ParticipantLeftConversation = 'ParticipantLeftConversation',
    ParticipantWasInvitedToConversation = 'ParticipantWasInvitedToConversation',
    ParticipantWasRemovedFromConversation = 'ParticipantWasRemovedFromConversation',
}
